import React from "react";
import { CommonIcon } from "../messages/utils";

export default function EmojiPicker({ getEmojiConfig, onSelect }) {
  const { EMOJI_ICON_MAP_CONFIG } = getEmojiConfig();
  const entries = Object.entries(EMOJI_ICON_MAP_CONFIG);
  return (
    <div className="imc-emoji-panel">
      <div className="imc-emoji-scroll">
        {entries.map(([key, iconType]) => (
          <div
            key={key}
            className="imc-emoji-item"
            onClick={() => onSelect(key)}
          >
            <CommonIcon type={iconType} style={{ fontSize: 24 }} />
          </div>
        ))}
      </div>
    </div>
  );
}
